module.exports = __webpack_public_path__ + "img/dashboard.28c41b9d.svg";